import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { clearSessionEndedMessage } from "actions/auth";
import styles from "components/Forms/FormStyles.module.scss";

const SessionEndedModal = () => {
    const message = useSelector((state) => state.auth.sessionEndedMessage);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!message) return;
        const onWebRoute = !/\/(roku|firetv|sky|app)(\/|$)/i.test(location.pathname);
        if (onWebRoute && location.pathname !== "/login") {
            navigate("/login");
        }
    }, [message]);

    if (!message) return null;

    const dismiss = () => dispatch(clearSessionEndedMessage());

    return (
        <div className={styles.appleWarningOverlay} onClick={dismiss}>
            <div className={styles.appleWarningModal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.sessionConflictIcon}>
                    <FontAwesomeIcon icon={faTriangleExclamation} />
                </div>
                <h2>Session Ended</h2>
                <p className={styles.appleWarningSubtitle}>{message}</p>
                <div className={styles.sessionConflictButtons}>
                    <button className={`${styles.button} ${styles.small}`} onClick={dismiss}>
                        Got it
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SessionEndedModal;
